/**
 * Converts a camelCase string to kebab-case.
 *
 * @param value The camelCase string to convert.
 * @returns The kebab-case version of the input string.
 */
export function camelToKebab(value: string): string {
    return value.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
